import React, { useRef } from 'react';
import { Box } from '@mui/material';
import { FormikSelectInput } from 'components/UI/Inputs/FormikInputs';
import { Form, Formik } from 'formik';
import { FormButton } from 'components';
import { useSetRecoilState } from 'recoil';
import { secondaryModalData } from 'recoilState/GlobalState';

export default function FormSelectRol({ roles, rows, participants, onSubmit }) {
    const formikRef = useRef();
    const setSecondaryModal = useSetRecoilState(secondaryModalData);

    // Para estados Publicado (P) y Firmado (F) solo se permiten lectores (no firmantes)
    const soloLectores = ['P', 'F'].includes(rows.documentoEstado);

    const defineFirstValueFormik = () => {
        const internoId = String(roles.find(r => r.sbmRolNombre === "Firmante Interno")?.sbmRolId ?? "");
        const externoId = String(roles.find(r => r.sbmRolNombre === "Firmante Externo")?.sbmRolId ?? "");
        const otroId = String(roles.find(r => r.sbmRolNombre !== "Firmante Interno" && r.sbmRolNombre !== "Firmante Externo")?.sbmRolId ?? "");

        if (!soloLectores && rows.firmantesInternos > participants.filter(e => e.rol === "Firmante Interno").length) {
            return { roles: internoId }
        } else if (!soloLectores && rows.firmantesExternos > participants.filter(e => e.rol === "Firmante Externo").length) {
            return { roles: externoId }
        } else {
            return { roles: otroId }
        }
    }

    return (
        <Formik
            enableReinitialize
            initialValues={defineFirstValueFormik()}
            onSubmit={onSubmit}
            innerRef={formikRef}
        >
            <Form>
                <FormikSelectInput name={"roles"} labelText={"Rol"}>
                    {
                        roles.map((rol) => (
                            rol.sbmRolNombre === "Firmante Interno" ?
                                !soloLectores && rows.firmantesInternos > participants.filter(e => e.rol === "Firmante Interno").length && <option value={rol.sbmRolId} key={rol.sbmRolId}>{rol.sbmRolNombre}</option> :
                                rol.sbmRolNombre === "Firmante Externo" ?
                                    !soloLectores && rows.firmantesExternos > participants.filter(e => e.rol === "Firmante Externo").length && <option value={rol.sbmRolId} key={rol.sbmRolId}>{rol.sbmRolNombre}</option> :
                                    <option value={rol.sbmRolId} key={rol.sbmRolId}>{rol.sbmRolNombre}</option>
                        ))
                    }
                </FormikSelectInput>
                <Box display={"flex"} width={"100%"} justifyContent={"center"} mt={10} gap={5}>
                    <FormButton
                        newFormData={{ button: "Continuar" }}
                        disableAutoClose
                        onCloseModal={() => setSecondaryModal({ isOpen: false })}
                    />
                </Box>
            </Form>
        </Formik>
    );
}
